import React from "react";
import styled from "styled-components";
import ViewAppBar from "../views/ViewAppBar";
import ViewRedefinirSenha from "../views/ViewRedefinirSenha";
import ViewFooter from "../views/ViewFooter";
import ContatoZap from "../components/ContatoZap";
import { useMediaQuery } from "react-responsive";

const ScreenContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
  position: relative;
  background: linear-gradient(135deg, #003644, #0096c7);
`;

const ContentArea = styled.main`
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  min-height: calc(100vh - 160px);
  padding: 2rem 1rem;
  transform: translateY(-30px); /* 🔹 Levemente abaixo do AppBar */
  transition: transform 0.3s ease;

  @media (max-width: 768px) {
    transform: translateY(-20px); /* menos deslocamento no mobile */
    padding: 1.5rem 1rem;
  }
`;

const ZapContainer = styled.div`
  position: fixed;
  bottom: 30px;
  right: 30px;
  z-index: 50;

  @media (max-width: 768px) {
    bottom: 15px;
    right: 15px;
  }
`;

const RedefinirSenha: React.FC = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return (
    <ScreenContainer>
      <ViewAppBar />

      {/* 🔹 Formulário levemente mais abaixo do header */}
      <ContentArea>
        <ViewRedefinirSenha />
      </ContentArea>

      <ViewFooter />

      {!isMobile && (
        <ZapContainer>
          <ContatoZap />
        </ZapContainer>
      )}
    </ScreenContainer>
  );
};

export default RedefinirSenha;
